import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { colors } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import { spacing } from '../../tokens/spacing/spacing.js';
import { fontWeight } from '../../tokens/fontWeight.js';
import '../../tokens/breakpoints/breakpoints.js';
import { fontFamily } from '../../tokens/font-family.js';

function Badge({ children, color = "info", borderRadius = "round", border = false, size = "medium", textTransform = "none", }) {
    return (jsx(MBadgeBox, { "$color": color, "$size": size, "$borderRadius": borderRadius, "$border": border, "$textTransform": textTransform, children: children }));
}
const MBadgeBox = styled.div `
  font-family: ${fontFamily.sansSerif};
  display: inline-block;
  text-align: center;
  text-wrap: nowrap;
  font-weight: ${fontWeight.medium};
  line-height: 1.1;
  text-transform: ${({ $textTransform }) => $textTransform};

  ${({ $size }) => {
    switch ($size) {
        case "x-small":
            return `
          padding: ${spacing.XS3} ${spacing.XS};
          font-size: 0.75rem;
          font-weight: ${fontWeight.regular};
          line-height: 1;
        `;
        case "small":
            return `
          padding: ${spacing.XS3} ${spacing.XS};
          font-size: 0.875rem;
          font-weight: ${fontWeight.regular};
          line-height: 1;
        `;
        case "medium":
            return `
          padding: ${spacing.XS2} ${spacing.XS};
          font-size: 0.875rem;
        `;
    }
}}

  ${({ $color, $border }) => {
    switch ($color) {
        case "info":
            return `
          background: ${colors.systemInfoLight};
          color: ${colors.systemInfoDark};
          border: ${$border ? `1px solid ${colors.systemInfoDark}` : `1px solid ${colors.systemInfoLight}`};
        `;
        case "error":
            return `
          background: ${colors.systemErrorLight};
          color: ${colors.systemErrorDark};
          border: ${$border ? `1px solid ${colors.systemErrorDark}` : `1px solid ${colors.systemErrorLight}`};
      `;
        case "neutral":
            return `
          background: ${colors.neutralDark};
          color: ${colors.textSecondary};
          border: ${$border ? `1px solid ${colors.textSecondary}` : `1px solid ${colors.neutralDark}`};
      `;
        case "good":
            return `
          background: ${colors.systemGoodLight};
          color: ${colors.systemGoodDark};
          border: ${$border ? `1px solid ${colors.systemGoodDark}` : `1px solid ${colors.systemGoodLight}`};
      `;
        case "warning":
            return `
          background: ${colors.systemWarningLight};
          color: ${colors.systemWarningDark};
          border: ${$border ? `1px solid ${colors.systemWarningDark}` : `1px solid ${colors.systemWarningLight}`};
      `;
        case "promotional":
            return `
          background: ${colors.accentPrimaryDark};
          color: ${colors.textContrast};
          border: ${$border ? `1px solid ${colors.textContrast}` : `1px solid ${colors.accentPrimaryDark}`};
      `;
    }
}}

${({ $borderRadius }) => {
    switch ($borderRadius) {
        case "round":
            return `
          border-radius: 50px;
        `;
        case "square":
            return `
          border-radius: 5px;
      `;
    }
}}
`;

export { Badge };
